import React from 'react';
import PropTypes from 'prop-types';
import { TranslatedMessage } from 'common/components/Intl';
import Button from 'common/components/Button';

export default function CalculatorPageHeroBanner({ shopNowPath }) {
  return (
    <>
      <h1 className="calculator-page__hero-banner-title">
        <TranslatedMessage id="page.calculator.title" />
      </h1>
      <div className="calculator-page__hero-banner-description row">
        <div className="col-xs-12 col-lg-10">
          <TranslatedMessage id="page.calculator.subtitle" />
        </div>
      </div>
      <Button href={shopNowPath}>
        <TranslatedMessage id="page.calculator.shop_now" />
      </Button>
    </>
  );
}

CalculatorPageHeroBanner.propTypes = {
  shopNowPath: PropTypes.string.isRequired,
};
